import UIkit from "uikit";

import Dialog from "../common/Dialog";

const InternalNoteDelete = ({ note, deleting, onDelete, onDeleted }) => {
  const handleDelete = async () => {
    if (!note || deleting) return;

    await onDelete(note);
    UIkit.modal("#modal-internal-note-delete").hide();
    onDeleted?.();
  };

  return (
    <Dialog id="modal-internal-note-delete">
      <div className="uk-modal-dialog uk-modal-body">
        <button
          className="uk-modal-close-default"
          type="button"
          uk-close="true"
        ></button>
        <h2 className="uk-modal-title">Delete Internal Note</h2>
        <p>
          Are you sure you want to permanently delete this Internal Note? This
          action cannot be undone.
        </p>
        <p className="uk-text-right">
          <button
            className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
            type="button"
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            className="uk-button hms-btn hms-gray-btn"
            type="button"
            onClick={handleDelete}
            disabled={deleting || !note}
          >
            {deleting ? <span data-uk-spinner="ratio: 0.5" /> : "Delete"}
          </button>
        </p>
      </div>
    </Dialog>
  );
};

export default InternalNoteDelete;
